import { first, Observable, switchMap } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { encodeUserContext } from './user-context.helpers';
import { WO_CONTEXT_HEADER, WO_USER_CONTEXT } from './user-context.config';

@Injectable()
export class UserContextInterceptor implements HttpInterceptor {
  private readonly userContext$ = inject(WO_USER_CONTEXT);

  public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.headers.has(WO_CONTEXT_HEADER)) {
      if (!req.headers.get(WO_CONTEXT_HEADER)) {
        return next.handle(
          req.clone({
            headers: req.headers.delete(WO_CONTEXT_HEADER),
          }),
        );
      }
      return next.handle(req);
    }

    return this.userContext$.pipe(first(), switchMap(userContext => {
      if (userContext) {
        return next.handle(
          req.clone({
            headers: req.headers.set(WO_CONTEXT_HEADER, encodeUserContext(userContext)),
          }),
        );
      }
      return next.handle(req);
    }));
  }
}
